import { ErrorOutline } from '@mui/icons-material';
import ErrorView from './ErrorView';

function InvalidInvite() {
  return (
    <ErrorView
      title="Invalid Invite"
      heading="Invite no longer valid"
      message='Your invite has expired or isn&apos;t valid for another reason. Contact your pool company to request a new invite or press "Request Access" on your portal login page.'
      buttonText="Go to Login"
      buttonUrl="/auth/sign-in"
      icon={ErrorOutline}
    />
  );
}

export default InvalidInvite;
